import { render, staticRenderFns } from "./uploadPay.vue?vue&type=template&id=4479ec51&scoped=true&"
import script from "./uploadPay.vue?vue&type=script&lang=js&"
export * from "./uploadPay.vue?vue&type=script&lang=js&"
import style0 from "./uploadPay.vue?vue&type=style&index=0&id=4479ec51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479ec51",
  null
  
)

export default component.exports